import './app.css';

import 'flowbite';
import './navbar';
import './current-year';